export default __webpack_public_path__ + "static/media/btn-futuristic-primary-side-right.6baaae22.png";